import React, { useState, useEffect } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { FiEdit } from 'react-icons/fi';
import { RiDeleteBin5Line } from 'react-icons/ri';
import PropTypes from 'prop-types';
import { BaseButton } from '../Buttons/Buttons';
import styles from './Dropdown.module.css';

export const Dropdown = ({ toEditGamePage, deleteGame }) => {
  const [dropdown, setDropdown] = useState(false);

  const updateDropdown = (e) => {
    e.stopPropagation();
    setDropdown(!dropdown);
  };
  useEffect(() => {
    const onClick = () => setDropdown(false);
    window.addEventListener('click', onClick);

    return () => {
      window.removeEventListener('click', onClick);
    }
  }, []);

  return (
    <div className={styles.moreOptionsWrapper} >
      <DropdownButton onClick={updateDropdown} />
      {dropdown &&
        <div className={styles.dropdown}>
          <DropdownItem
            onClick={toEditGamePage}
            title='Edit'
            label='Edit-game'
          >
            <FiEdit className={styles.icon} />
          </DropdownItem>
          <DropdownItem
            onClick={deleteGame}
            title='Delete'
            label='Delete-game'
          >
            <RiDeleteBin5Line className={styles.icon} />
          </DropdownItem>
        </div>
      }
  </div>
  );
};

Dropdown.propTypes = {
  deleteGame: PropTypes.func,
  toEditGamePage: PropTypes.func,
}

export const DropdownButton = ({ onClick, dropdown }) => {
  return (
      <BsThreeDots
        aria-label='open-dropdown'
        aria-expanded={dropdown}
        className={styles.moreOptions}
        onClick={onClick}
      />
  );
};

DropdownButton.propTypes = {
  onClick: PropTypes.func,
  dropdown: PropTypes.bool,
};

export const DropdownItem = ({ onClick, children, title, label }) => {
  return (
    <div className={styles.item}>
    <BaseButton
      label={label}
      className={styles.button}
      onClick={onClick}>
      <div className={styles.innerItem}>
        <span className={styles.content}>
          <span>{children}</span>
          <p>{title}</p>
        </span>
      </div>
    </BaseButton>
  </div>
  );
};
DropdownItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.object,
  title: PropTypes.string,
  label: PropTypes.string,
};
